import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { useAuth } from '../../hooks/useAuth';
import { useLanguage } from '../../contexts/LanguageContext';

export default function AdminScreen() {
  const { appUser } = useAuth();
  const { t } = useLanguage();
  const router = useRouter();

  const isAdmin = appUser?.role === 'admin';

  if (!isAdmin) {
    return <View style={styles.center}><Text style={styles.noAccess}>{t('admin.noAccess')}</Text></View>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.innerContent}>
        <View style={styles.header}>
          <Text style={styles.title}>{t('admin.title')}</Text>
        </View>

        <TouchableOpacity style={styles.card} onPress={() => router.push('/(app)/admin-users')}>
          <View style={styles.cardIcon}>
            <Text style={styles.cardIconText}>👥</Text>
          </View>
          <View style={styles.cardBody}>
            <Text style={styles.cardTitle}>{t('admin.userManagement')}</Text>
            <Text style={styles.cardDesc}>{t('admin.userManagementDesc')}</Text>
          </View>
          <Text style={styles.cardChevron}>›</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.card} onPress={() => router.push('/(app)/scheduler')}>
          <View style={styles.cardIcon}>
            <Text style={styles.cardIconText}>⏰</Text>
          </View>
          <View style={styles.cardBody}>
            <Text style={styles.cardTitle}>{t('admin.scheduler')}</Text>
            <Text style={styles.cardDesc}>{t('admin.schedulerDesc')}</Text>
          </View>
          <Text style={styles.cardChevron}>›</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#F8FAFC' },
  innerContent: { flex: 1, maxWidth: 960, width: '100%', alignSelf: 'center', padding: 16 },
  center: { flex: 1, justifyContent: 'center', alignItems: 'center' },
  noAccess: { fontSize: 18, color: '#6B7280' },
  header: { paddingVertical: 8, marginBottom: 16, borderBottomWidth: 1, borderBottomColor: '#E2E8F0' },
  title: { fontSize: 22, fontWeight: 'bold', color: '#1E293B' },
  card: {
    backgroundColor: '#FFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  cardIcon: { width: 44, height: 44, borderRadius: 10, backgroundColor: '#EFF6FF', justifyContent: 'center', alignItems: 'center', marginRight: 14 },
  cardIconText: { fontSize: 22 },
  cardBody: { flex: 1 },
  cardTitle: { fontSize: 16, fontWeight: '700', color: '#1E293B' },
  cardDesc: { fontSize: 13, color: '#64748B', marginTop: 2 },
  cardChevron: { fontSize: 24, color: '#CBD5E1', marginLeft: 8 },
});
